import axios from "axios";
import {GET_TOUR_LOADINGS} from "../routes";

export default {
    async get(tour, options = {}) {
        return await axios.get(GET_TOUR_LOADINGS(tour), options)
    }
}
